import { Box } from "@mui/material";
import React from "react";
import CustomTopTabbar from "../../../../components/CustomTopTabbar";
import NotifCard from "../NotifCard";

export default function TabsContent() {
  const labels = [
    {
      label: "همه",
    },
    {
      label: "بارها",
    },
    {
      label: "حساب کاربری",
    },
    {
      label: "کارن‌کلاب",
    },
    // {
    //   label: "کارن‌کلاب",
    // },
    // {
    //   label: "کارن‌کلاب",
    // },
  ];

  return (
    <>
      <CustomTopTabbar labels={labels} />

      <Box
        sx={{
          flex: 1,
          boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.2) inset",

          display: "flex",
          flexDirection: "column",
          gap: "20px",
          overflowY: "scroll",
          paddingX: "8px",
          paddingY: "16px",
        }}
      >
        <NotifCard />
        <NotifCard />
        <NotifCard />
        <NotifCard />
        <NotifCard />
        <NotifCard />
        <NotifCard />
        <NotifCard />
        <NotifCard />
        <NotifCard />
      </Box>
    </>
  );
}
